import { StateCreator } from 'zustand';
import { DocgenClient } from '../../data/docgenClient';
import { DownloadFileResponse } from '../../data/interfaces/DocumentTemplateFile';
import { t } from '../../utils';
import { storeResetFns, useAppStore } from '.';

type State = {
	documentFileDownloadUrl: string;
	documentFile: Blob;
};

type Actions = {
	fetchDocumentFileDownloadUrl: (documentRID?: string) => Promise<void>;
	fetchDocumentDataUrl: (downloadUrl: string) => Promise<void>;
	resetDocumentUrlSliceData: (resType?) => void;
};

export type DownloadDocumentUrlState = State & Actions;

const initialState = {
	documentFileDownloadUrl: null,
	documentFile: null,
};

export const createDocumentUrlSlice: StateCreator<DownloadDocumentUrlState> = (
	set,
	get
) => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		fetchDocumentFileDownloadUrl: async (documentRID?: string) => {
			const { fetchDocumentDataUrl } = get();

			if (!documentRID) {
				const document = useAppStore.getState().document;
				documentRID = document.rid;
			}

			try {
				const downloadDocumentFileResponse: DownloadFileResponse =
					await DocgenClient.downloadDocumentFile(documentRID);
				const documentFileDownloadUrl = downloadDocumentFileResponse.downloadUrl;
				set({ documentFileDownloadUrl });
				return await fetchDocumentDataUrl(documentFileDownloadUrl);
			} catch {
				throw new Error(t('errorMessages.fetchFileError'));
			}
		},
		fetchDocumentDataUrl: async downloadUrl => {
			try {
				const response = await fetch(downloadUrl, {
					method: 'GET',
				});
				const blob = await response.blob();

				set({
					documentFile: blob,
				});
			} catch {
				throw new Error(t('errorMessages.fetchPdfFileError'));
			}
		},
		resetDocumentUrlSliceData: () => {
			set(initialState);
		},
	};
};
